import { render, staticRenderFns } from "./RegisterBidderView.vue?vue&type=template&id=3b7a185a&scoped=true&"
import script from "./RegisterBidderView.vue?vue&type=script&lang=js&"
export * from "./RegisterBidderView.vue?vue&type=script&lang=js&"
import style0 from "./RegisterBidderView.vue?vue&type=style&index=0&id=3b7a185a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a185a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VApp } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperContent } from 'vuetify/lib'
import { VStepperHeader } from 'vuetify/lib'
import { VStepperItems } from 'vuetify/lib'
import { VStepperStep } from 'vuetify/lib'
installComponents(component, {VAlert,VApp,VDivider,VFooter,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
